import React from "react";
import {
  fetchTemplateList,
  fetchAddEquipment,
  fetchEditEquipment,
} from "../../../../api/equipment";
import { Form, Input, Modal, Select, message } from "antd";

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
};
const { Option } = Select;
class EditEmployee extends React.Component {
  state = {
    templateList: [],
    loading: false,
  };
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        if (this.props.equipmentInfo.capsuleId) {
          fetchEditEquipment({
            ...values,
            capsuleId: this.props.equipmentInfo.capsuleId,
          })
            .then((res) => {
              if (res.success) {
                message.success("编辑成功");
                this.props.handleCancel();
                this.props.getEquipmentList();
              }
            })
            .finally(() => {
              this.setState({
                loading: false,
              });
            });
        } else {
          fetchAddEquipment(values)
            .then((res) => {
              if (res.success) {
                message.success("新增成功");
                this.props.handleCancel();
                this.props.getEquipmentList();
              }
            })
            .finally(() => {
              this.setState({
                loading: false,
              });
            });
        }
      }
    });
  };
  componentDidMount() {}
  typeChange = (e) => {
    let temp = { type: e };
    this.props.form.resetFields("templateId");
    this.getTemplateList(temp);
  };
  getTemplateList = (temp) => {
    fetchTemplateList(temp).then((res) => {
      if (temp.type == "EV200") {
        temp.type = "EV200";
      }
      res.data = res.data ? res.data : [];
      res.data = res.data.filter((item) => item.type == temp.type);
      this.setState({
        templateList: res.data,
      });
    });
  };
  renderOptions = () => {
    let templateList = this.props.equipmentInfo.capsuleId
      ? [
          {
            name: this.props.equipmentInfo.type,
            id: this.props.equipmentInfo.templateId,
          },
        ]
      : this.state.templateList;
    return templateList.map((item) => (
      <Option key={item.id} value={item.id}>
        {item.name}
      </Option>
    ));
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading } = this.state;
    const { visible, equipmentInfo, handleCancel } = this.props;
    return (
      <Modal
        destroyOnClose={true}
        title={equipmentInfo.capsuleId ? "编辑设备" : "新增设备"}
        visible={visible}
        onOk={this.handleOk}
        onCancel={handleCancel}
        okButtonProps={{ loading }}
      >
        <Form onSubmit={this.handleOk} {...formItemLayout}>
          <Form.Item label="设备类型">
            {getFieldDecorator(
              "type",
              equipmentInfo.type
                ? {
                    initialValue: equipmentInfo.type,
                    rules: [{ required: true, message: "请选择设备类型" }],
                  }
                : {
                    rules: [{ required: true, message: "请选择设备类型" }],
                  }
            )(
              <Select
                onChange={this.typeChange}
                disabled={!!equipmentInfo.type}
                placeholder="请选择设备类型"
                allowClear
              >
                <Option value="EV200">EV200</Option>
                <Option value="X5">X5</Option>
              </Select>
            )}
          </Form.Item>
          {equipmentInfo.capsuleId ? (
            <Form.Item label="设备模板">
              {getFieldDecorator("templateId", {
                initialValue: equipmentInfo.templateId,
                rules: [{ required: true, message: "请选择设备模板" }],
              })(
                <Select placeholder="请选择设备模板">
                  {this.renderOptions()}
                </Select>
              )}
            </Form.Item>
          ) : (
            <Form.Item label="设备模板">
              {getFieldDecorator("templateId", {
                rules: [{ required: true, message: "请选择设备模板" }],
              })(
                <Select placeholder="请选择设备模板">
                  {this.renderOptions()}
                </Select>
              )}
            </Form.Item>
          )}
          <Form.Item label="控制板编号">
            {getFieldDecorator("roboId", {
              initialValue: equipmentInfo.roboId,
              rules: [{ required: true, message: "请输入控制板编号" }],
            })(<Input placeholder="控制板编号" />)}
          </Form.Item>
          <Form.Item label="设备编号">
            {getFieldDecorator("capsuleNo", {
              initialValue: equipmentInfo.capsuleNo,
              rules: [{ required: true, message: "请输入设备编号" }],
            })(<Input placeholder="设备编号" />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(EditEmployee);
